
 document.querySelectorAll('.custom-options').forEach(button => {
    button.addEventListener('click',  function () {
      // Add to cart button click

	
	const card = this.closest('.product-card');
	const productHandle = card.dataset.handle;
	
  
  let selectedOptions = [];
	let option_1 = card.querySelector('.custom-option[data-option-position="1"]:checked'),
  option_2 = card.querySelector('.custom-option[data-option-position="2"]:checked');

  if(option_1){
  let selectedOption1 = option_1.dataset.name;
  selectedOptions.push(selectedOption1);
  }

  if(option_2){
    let selectedOption2 = option_2.dataset.name; 
    selectedOptions.push(selectedOption2);
  }
  
	
	
	const quantity = 1;

      fetch(`/products/${productHandle}.js`).then(function(response) {
        return response.json();
      }).then(function(product) {
        
        const variant = product.variants.find(function(variant) {
          return variant.options.every(function(option, index) {
            return option === selectedOptions[index];
          });
        });
        
        if (!variant) {
          return;
        }
        console.log('Matched Variant:', variant);

        return fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            id: variant.id,
            quantity: quantity
          })
        });
      }).then(function(response) {
        if (!response) return;
        return response.json();
      }).then(function(cart) {
        if (!cart) return;
        console.log('Cart Response:', cart);
       document.dispatchEvent(new CustomEvent("cart:refresh"));
       document.querySelector('.header__cart-link a[href="/cart"]').click();

      }).catch(function(error) {
        console.error(error);
        alert('Something went wrong');
      });


      

    });
  });

  
document.addEventListener("DOMContentLoaded", function() {
  // Select all carousels
  const carousels = document.querySelectorAll(".size-carousel");

  carousels.forEach((carousel) => {

    const slider = carousel.querySelector(".size-sildes");
    const slides = carousel.querySelectorAll(".size-slide");

    const prevBtn = carousel.querySelector(".prev");
    const nextBtn = carousel.querySelector(".next");

    if (!slider || !slides.length) return;

    let currentIndex = 0;

    // Get single slide width
    function getSlideWidth() {
      return slides[0].getBoundingClientRect().width;
    }

    // Get visible slides count
    function getVisibleSlides() {
      const wrapper = carousel.querySelector(".size-slider-wrapper");
      return Math.floor(wrapper.offsetWidth / getSlideWidth());
    }

    // Update slider position
    function updateCarousel() {

      const slideWidth = getSlideWidth();

      slider.style.transform =
        `translateX(-${currentIndex * slideWidth}px)`;

      // Disable previous button
      prevBtn.disabled = currentIndex === 0;

      // Disable next button
      nextBtn.disabled =
        currentIndex >= slides.length - getVisibleSlides();
    }

    // Next button click
    nextBtn.addEventListener("click", function (e) {
      e.preventDefault()

      if (currentIndex < slides.length - getVisibleSlides()) {
        currentIndex++;
        updateCarousel();
      }

    });

    // Previous button click
    prevBtn.addEventListener("click", function (e) {
       e.preventDefault()

      if (currentIndex > 0) {
        currentIndex--;
        updateCarousel();
      }

    });

    // Responsive update
    window.addEventListener("resize", function () {
      updateCarousel();
    });

    // Initialize
    updateCarousel();

  });
});



 